/**
 * Lucide glyphs for the banner icon keys. The canonical key list is
 * `BANNER_ICONS` in `@ordo/schema` (validated server-side); this map only
 * owns the name → component rendering. Unknown keys fall back to Megaphone.
 */

import type { LucideIcon } from 'lucide-react'
import { AlertCircle, AlertTriangle, Bell, Calendar, Gift, Info, Megaphone } from 'lucide-react'

export const BANNER_ICON_MAP: Record<string, LucideIcon> = {
  INFO: Info,
  ALERT_TRIANGLE: AlertTriangle,
  ALERT_CIRCLE: AlertCircle,
  BELL: Bell,
  MEGAPHONE: Megaphone,
  CALENDAR: Calendar,
  GIFT: Gift,
}

export function bannerIcon(key: string): LucideIcon {
  return BANNER_ICON_MAP[key] ?? Megaphone
}
